'use strict';

import React from 'react';
import { connect } from 'react-redux';
import LabelComponent from './labelViewer.component';
import LabelViewerQuery from './labelViewer.query';
import dispatchQuery from 'helpers/dispatchQuery';

class LabelViewerContainer extends React.Component {

  fetchChildLabels (labelId, parentId) {
    const { dispatch } = this.props,
          query = LabelViewerQuery.getChildLabels(labelId, parentId),
          objectNameResult = 'labelViewerLabels',
          schemaName = 'weightedLabels';

    if (labelId) {
      dispatchQuery(dispatch, query, objectNameResult, schemaName);
    }
  }

  fetchTier1Labels () {
    const { dispatch } = this.props,
          query = LabelViewerQuery.getTier1Labels(-1),
          objectNameResult = 'labelViewerLabels',
          schemaName = 'labels';
    dispatchQuery(dispatch, query, objectNameResult, schemaName);
  }

  fetchLabelDetails (dispatch, labelId) {
    const query =  LabelViewerQuery.getLabelDetails(labelId);
    dispatchQuery(dispatch, query, 'labelDetails','labelDetails');
  }

  fetchParentLabel (dispatch, labelId, parentId) {
    const query = LabelViewerQuery.getParentsLabelQuery(labelId, parentId);
    dispatchQuery(dispatch, query, 'labelParents', 'labelParents');
  }

  fetchLabelsByName (labelName) {
    const { dispatch } = this.props;
    const query = LabelViewerQuery.getLabelsByName(labelName);
    dispatchQuery(dispatch, query, 'filteredLabels', 'filteredLabels');
  }

  componentWillMount () {
    this.setState({urlLabelChecker: null});
  }

  componentDidMount () {
    this.fetchChildLabels(this.props.params.labelId);
  }

  componentWillReceiveProps (nextProps) {
    const { labelId, parentId } = nextProps.params;
    this.state.urlLabelChecker = parseInt(nextProps.params.labelId);
    if (!!labelId) {
      this.fetchChildLabels(labelId, parentId);
    } else {
      this.fetchTier1Labels();
    }
  }

  render() {
    const urlLabelChecker = !!this.state.urlLabelChecker ? this.state.urlLabelChecker : null;
    return (
      <div className="Grid">
        <div className="Grid-cell--1">
          <div className="Grid-content">
            <LabelComponent fetchTier1Labels={this.fetchTier1Labels.bind(this)} urlLabelChecker={urlLabelChecker} fetchLabelsByName={this.fetchLabelsByName.bind(this)}/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(LabelViewerContainer);



// WEBPACK FOOTER //
// ./src/components/labelViewer/labelViewer.container.jsx